import { getPublicApplication } from '@insight2profit/micro-services';
import { ProvideAuth, ProvideSnackbar, RouterProvider } from 'context-providers';
import { AppContextProvider } from 'context-providers/AppContext';
import { InsightServiceLibrary } from 'library/InsightServiceLibrary';
import React from 'react';
import ReactDOM from 'react-dom';
import { getRuntimeEnvironment } from 'startup/getRuntimeEnvironment';
import { registerGoogleAnalytics } from 'startup/registerGoogleAnalytics';
import App from './App';
import reportWebVitals from './reportWebVitals';

const run = async () => {
  const runtimeEnvironment = await getRuntimeEnvironment();

  const { googleAnalyticsId } = runtimeEnvironment;
  const clientApp = getPublicApplication({
    authorityUrl: runtimeEnvironment.identityServiceAuthorityUrl,
    cacheLocation: 'localStorage',
    clientId: runtimeEnvironment.identityServiceClientId,
  });
  const insightApi = new InsightServiceLibrary({ runtimeEnvironment: runtimeEnvironment, clientApp });

  ReactDOM.render(
    <React.StrictMode>
      <RouterProvider>
        <AppContextProvider
          insightApi={insightApi}
          runtimeConfig={runtimeEnvironment}
          clientApp={clientApp}
          pageLoadTimestamp={Date.now()}
        >
          <ProvideSnackbar>
            <ProvideAuth clientApp={clientApp}>
              <App />
            </ProvideAuth>
          </ProvideSnackbar>
        </AppContextProvider>
      </RouterProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );

  if (googleAnalyticsId) {
    registerGoogleAnalytics(googleAnalyticsId);
  }

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};

run();
